import styled from 'styled-components';
import ErrorSharpIcon from '@mui/icons-material/ErrorSharp';

import colors from '../../styles/colors';

const ErrorContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

const ErrorIcon = styled(ErrorSharpIcon)`
  width: 25px;
  color: ${colors.shades.danger1}
`;

const ErrorMessage = styled.div`
  margin: 10px;
  text-align: center;
`;

export {
  ErrorContainer,
  ErrorMessage,
  ErrorIcon,
};
